(function () {
  const isSweepstakeTemplate = document.body.classList.contains('template-sweepstake');
  const hasSweepstakeSection = !!document.querySelector('.sweepstake-section');
  if (!isSweepstakeTemplate && !hasSweepstakeSection) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  // ── Add-to-cart for all [data-sweep-atc] buttons ─────────────────────────
  //
  // Requires window.sweepstakeTicketVariantId to be set in sweepstake-hero.liquid.
  // Flow:
  //   1. Click → POST to /cart/add.js with the ticket variant ID
  //   2. Success → open the theme cart drawer (Dawn CartDrawer component)
  //   3. If cart drawer not found → redirect to cart page
  //   4. If no variant ID → redirect to fallback URL (product page / checkout)
  // ─────────────────────────────────────────────────────────────────────────

  const openCartDrawer = () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }
    return false;
  };

  const refreshCartDrawer = async () => {
    // Dawn re-renders the drawer by dispatching a custom event
    // or via the CartDrawerItems component that extends CartItems.
    // The cleanest native way is to fire the same event the theme uses.
    const event = new CustomEvent('cart:refresh', { bubbles: true });
    document.dispatchEvent(event);

    // Fallback: fetch the cart drawer section and update its HTML
    try {
      const res = await fetch(`${window.Shopify?.routes?.root ?? '/'}?sections=cart-drawer`);
      if (!res.ok) return;
      const data = await res.json();
      const html = data['cart-drawer'];
      if (!html) return;
      const temp = document.createElement('div');
      temp.innerHTML = html;
      const newDrawer = temp.querySelector('cart-drawer');
      const existingDrawer = document.querySelector('cart-drawer');
      if (newDrawer && existingDrawer) {
        existingDrawer.innerHTML = newDrawer.innerHTML;
      }
    } catch (_) { /* silent */ }
  };

  const sweepstakeAddToCart = async (btn) => {
    const variantId = window.sweepstakeTicketVariantId;
    const fallbackUrl = btn.dataset.sweepAtcRedirect
      || window.sweepstakeTicketUrl
      || '/products/sweepstake-play-ticket';

    // No variant ID configured — fallback to link
    if (!variantId) {
      window.location.href = fallbackUrl;
      return;
    }

    const labelEl = btn.querySelector('[data-sweep-atc-label]');
    const originalLabel = labelEl ? labelEl.textContent : '';

    // Loading state
    btn.disabled = true;
    if (labelEl) labelEl.textContent = 'Adding...';

    try {
      const cartAddUrl = window.routes?.cart_add_url ?? '/cart/add.js';
      const res = await fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        // Out of stock or unavailable
        if (res.status === 422 || err?.status === 422) {
          if (labelEl) labelEl.textContent = 'Sold Out';
          btn.disabled = true;
          return;
        }
        throw new Error(`Cart add failed: ${res.status}`);
      }

      // Success — refresh drawer content then open it
      await refreshCartDrawer();
      const opened = openCartDrawer();

      if (!opened) {
        // No drawer available — go to cart page
        window.location.href = window.routes?.cart_url ?? '/cart';
      }
    } catch (err) {
      console.error('[sweepstake] add-to-cart error:', err);
      // Fallback to product link on any unexpected error
      window.location.href = fallbackUrl;
    } finally {
      // Restore label unless sold out
      if (btn.disabled === false || (labelEl && labelEl.textContent === 'Adding...')) {
        btn.disabled = false;
        if (labelEl) labelEl.textContent = originalLabel;
      }
    }
  };

  document.querySelectorAll('[data-sweep-atc]').forEach((btn) => {
    btn.addEventListener('click', () => sweepstakeAddToCart(btn));
  });

  // ── Auto-fill ticket code from URL ?code= param (set by checkout extension) ──
  const urlCode = new URLSearchParams(window.location.search).get('code');
  if (urlCode) {
    // Wait for DOM to be ready then pre-fill and auto-scroll to quiz
    const tryPrefill = () => {
      const codeInput = document.querySelector('[data-ticket-code]');
      if (!codeInput) return;
      codeInput.value = urlCode.trim().toUpperCase();

      // Scroll to quiz section smoothly
      const quizSection = document.querySelector('#SweepstakeQuiz');
      if (quizSection) {
        quizSection.scrollIntoView({
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
          block: 'start',
        });
      }

      // Remove the code from the URL so it doesn't stay visible or get shared
      const cleanUrl = window.location.pathname + window.location.hash;
      window.history.replaceState({}, '', cleanUrl);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tryPrefill);
    } else {
      tryPrefill();
    }
  }

  const revealTargets = document.querySelectorAll('[data-sweep-reveal], [data-sweep-fade]');
  revealTargets.forEach((target, index) => {
    target.style.setProperty('--sweep-delay', `${Math.min(index % 6, 5) * 70}ms`);
  });

  if ('IntersectionObserver' in window && !prefersReducedMotion) {
    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.18, rootMargin: '0px 0px -10% 0px' }
    );
    revealTargets.forEach((target) => revealObserver.observe(target));
  } else {
    revealTargets.forEach((target) => target.classList.add('is-visible'));
  }

  document.querySelectorAll('[data-scroll-target]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const target = document.querySelector(trigger.getAttribute('data-scroll-target'));
      if (!target) return;
      target.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
    });
  });

  document.querySelectorAll('a[href^="#Sweepstake"]').forEach((anchor) => {
    anchor.addEventListener('click', (event) => {
      const target = document.querySelector(anchor.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
    });
  });

  document.querySelectorAll('[data-story]').forEach((story) => {
    const frames = Array.from(story.querySelectorAll('[data-story-frame]'));
    const media = Array.from(story.querySelectorAll('[data-story-media]'));
    if (!frames.length || !media.length) return;

    const activate = (index) => {
      frames.forEach((frame, frameIndex) => frame.classList.toggle('is-active', frameIndex === index));
      media.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === index));
      story.style.setProperty('--sweep-media-lift', `${index * 6}px`);
      story.style.setProperty('--sweep-panel-shift', `${index * 8}px`);
      story.style.setProperty('--sweep-panel-scale', `${1.015 + index * 0.003}`);
    };

    if ('IntersectionObserver' in window && !prefersReducedMotion) {
      const storyObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            activate(Number(entry.target.dataset.storyIndex || 0));
          });
        },
        { threshold: 0.55, rootMargin: '-15% 0px -15% 0px' }
      );
      frames.forEach((frame) => storyObserver.observe(frame));
    }
  });

  document.querySelectorAll('[data-explorer]').forEach((explorer) => {
    const tabs = Array.from(explorer.querySelectorAll('[data-explorer-tab]'));
    const panels = Array.from(explorer.querySelectorAll('[data-explorer-panel]'));
    const media = Array.from(explorer.querySelectorAll('[data-explorer-media]'));
    if (!tabs.length) return;

    const activate = (index) => {
      tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
      });
      panels.forEach((panel, panelIndex) => panel.classList.toggle('is-active', panelIndex === index));
      media.forEach((item, mediaIndex) => item.classList.toggle('is-active', mediaIndex === index));
      explorer.style.setProperty('--sweep-media-lift', `${index * 4}px`);
      explorer.style.setProperty('--sweep-panel-shift', `${index * 6}px`);
      explorer.style.setProperty('--sweep-panel-scale', `${1.012 + index * 0.002}`);
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activate(Number(tab.dataset.explorerIndex || 0)));
    });
  });

  document.querySelectorAll('[data-count]').forEach((node) => {
    const target = Number(node.getAttribute('data-count'));
    if (!target || Number.isNaN(target)) return;

    const run = () => {
      const start = performance.now();
      const duration = 1100;
      const formatter = new Intl.NumberFormat();

      const tick = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        node.textContent = formatter.format(Math.round(target * eased));
        if (progress < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };

    if ('IntersectionObserver' in window && !prefersReducedMotion) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          run();
          observer.disconnect();
        });
      }, { threshold: 0.6 });
      observer.observe(node);
    } else {
      node.textContent = new Intl.NumberFormat().format(target);
    }
  });

  document.querySelectorAll('[data-quiz]').forEach((quiz) => {
    // --- Config from Liquid data attributes ---
    const API_BASE   = (quiz.dataset.apiBase || '').replace(/\/$/, '');
    const SHOP       = quiz.dataset.shop || '';
    const WIN_THRESHOLD = Number(quiz.dataset.winThreshold || 10);
    const TOTAL_Q    = Number(quiz.dataset.totalQuestions || 15);
    const SECS_PER_Q = Number(quiz.dataset.secondsPerQuestion || 15);

    // --- DOM refs ---
    const gateEl     = quiz.querySelector('[data-quiz-gate]');
    const bodyEl     = quiz.querySelector('[data-quiz-body]');
    const successEl  = quiz.querySelector('[data-quiz-success]');
    const lostEl     = quiz.querySelector('[data-quiz-lost]');
    const retryBtn   = quiz.querySelector('[data-quiz-retry]');
    const codeInput  = quiz.querySelector('[data-ticket-code]');
    const validateBtn= quiz.querySelector('[data-validate-ticket]');
    const gateError  = quiz.querySelector('[data-gate-error]');
    const progress   = quiz.querySelector('[data-quiz-progress]');
    const counter    = quiz.querySelector('[data-quiz-counter]');
    const timerValue = quiz.querySelector('[data-quiz-timer-value]');
    const lostScore  = quiz.querySelector('[data-lost-score]');
    const winScore   = quiz.querySelector('[data-win-score]');
    const resultError = quiz.querySelector('[data-quiz-result-error]');
    const questions  = Array.from(quiz.querySelectorAll('[data-quiz-question]'));

    if (!gateEl || !questions.length) return;

    // --- State ---
    let ticketId   = null;
    let ticketCode = null;
    let current    = 0;
    let score      = 0;
    let totalTime  = 0;
    let questionStart = 0;
    let timerInterval = null;
    let secondsLeft   = SECS_PER_Q;

    // --- Helpers ---
    const showError = (node, msg) => {
      if (!node) return;
      node.textContent = msg;
      node.hidden = false;
    };

    const hideError = (node) => {
      if (!node) return;
      node.hidden = true;
      node.textContent = '';
    };

    const setButtonBusy = (btn, busy) => {
      btn.disabled = busy;
      btn.setAttribute('aria-busy', String(busy));
    };

    const scrollQuizIntoView = () => {
      const target = quiz.querySelector('.sweepstake-quiz__frame') || quiz;
      window.setTimeout(() => {
        target.scrollIntoView({
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
          block: 'start',
        });
      }, prefersReducedMotion ? 0 : 60);
    };

    const clearResultError = () => {
      if (!resultError) return;
      resultError.hidden = true;
      resultError.textContent = '';
    };

    const showResultError = (msg) => {
      if (!resultError) return;
      resultError.hidden = false;
      resultError.textContent = msg;
    };

    const setWinnerState = ({ scoreText, sweepstakeNumber, alreadyRecorded = false }) => {
      if (bodyEl) bodyEl.hidden = true;
      if (gateEl) gateEl.hidden = true;
      if (successEl) successEl.hidden = false;
      if (lostEl) lostEl.hidden = true;
      clearResultError();

      if (winScore) {
        winScore.textContent = alreadyRecorded
          ? 'This ticket already won. Your official sweepstake number is shown below.'
          : scoreText;
      }

      const entryNumberEl = quiz.querySelector('[data-entry-number]');
      const entryNumberVal = quiz.querySelector('[data-entry-number-value]');
      if (entryNumberEl && entryNumberVal && sweepstakeNumber != null) {
        entryNumberVal.textContent = `#${String(sweepstakeNumber).padStart(3, '0')}`;
        entryNumberEl.hidden = false;
      }
    };

    // --- Timer ---
    const timerEl = quiz.querySelector('[data-quiz-timer]');

    const startTimer = () => {
      clearInterval(timerInterval);
      secondsLeft = SECS_PER_Q;
      questionStart = Date.now();
      if (timerValue) timerValue.textContent = secondsLeft;
      if (timerEl) timerEl.removeAttribute('data-urgent');
      timerInterval = setInterval(() => {
        secondsLeft -= 1;
        if (timerValue) timerValue.textContent = secondsLeft;
        // Mark urgent when 5s or less remain
        if (timerEl) timerEl.toggleAttribute('data-urgent', secondsLeft <= 5);
        if (secondsLeft <= 0) {
          clearInterval(timerInterval);
          advanceQuestion(false, SECS_PER_Q * 1000);
        }
      }, 1000);
    };

    const stopTimer = () => clearInterval(timerInterval);

    // --- Quiz render ---
    const render = () => {
      questions.forEach((q, i) => q.classList.toggle('is-active', i === current));
      if (progress) progress.style.width = `${((current + 1) / TOTAL_Q) * 100}%`;
      if (counter) counter.textContent = `${current + 1} / ${TOTAL_Q}`;
      startTimer();
    };

    // --- Advance after answer ---
    const advanceQuestion = (correct, elapsed) => {
      stopTimer();
      totalTime += Math.round(elapsed / 1000);
      if (correct) score += 1;

      window.setTimeout(() => {
        if (current >= questions.length - 1) {
          finishQuiz();
          return;
        }
        current += 1;
        render();
      }, prefersReducedMotion ? 0 : 320);
    };

    // --- Finish: call backend ---
    const finishQuiz = async () => {
      questions.forEach((q) => q.classList.remove('is-active'));
      if (progress) progress.style.width = '100%';
      clearResultError();

      const won = score >= WIN_THRESHOLD;

      // If won, we need entry data first — show entry form inline or
      // pass data from the already-rendered sweepstake-entry-form.
      // For now we submit the result without entry data; the entry form
      // route /api/sweepstake/submit-entry handles pairing via ticketId.
      try {
        const submitPayload = {
          shop: SHOP,
          ticketId,
          code: ticketCode,
          score,
          totalTime,
          // entry data is collected in sweepstake-entry-form after win
        };

        let data = null;
        let lastError = null;

        for (let attempt = 0; attempt < 3; attempt += 1) {
          try {
            const res = await fetch(`${API_BASE}/api/sweepstake/submit-entry`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(submitPayload),
            });

            data = await res.json();

            if (data.ok || data.error === 'already_won') {
              break;
            }

            lastError = data;
          } catch (err) {
            lastError = err;
          }

          if (attempt < 2) {
            await new Promise((resolve) => window.setTimeout(resolve, 500 * (attempt + 1)));
          }
        }

        if (won && data && (data.ok || data.error === 'already_won') && data.sweepstakeNumber != null) {
          setWinnerState({
            scoreText: `Your score: ${score} / ${TOTAL_Q}.`,
            sweepstakeNumber: data.sweepstakeNumber,
            alreadyRecorded: !data.ok,
          });
          document.dispatchEvent(new CustomEvent('sweepstake:quiz-won', {
            detail: { ticketId, score, sweepstakeNumber: data.sweepstakeNumber }
          }));
          // quiz-complete unlocks the entry form section below the quiz frame
          document.dispatchEvent(new CustomEvent('sweepstake:quiz-complete', {
            detail: { ticketId, score, sweepstakeNumber: data.sweepstakeNumber }
          }));
        } else if (won) {
          if (successEl) successEl.hidden = false;
          showResultError('You passed the quiz, but we could not confirm your official entry number yet. Please try your ticket code again in a moment so we can recover your number.');
          console.error('[sweepstake] submit-entry could not confirm winner payload:', lastError || data);
        } else {
          // Lost
          if (bodyEl) bodyEl.hidden = true;
          if (gateEl) gateEl.hidden = true;
          if (lostEl) {
            lostEl.hidden = false;
            if (lostScore) {
              lostScore.textContent = `Your score: ${score} / ${TOTAL_Q}. You needed ${WIN_THRESHOLD}. Try again — your ticket is still valid.`;
            }
          }
        }
      } catch (err) {
        console.error('[sweepstake] submit-entry error:', err);
        if (won) {
          if (successEl) successEl.hidden = false;
          showResultError('You passed the quiz, but we could not confirm your official entry number yet. Please try your ticket code again in a moment so we can recover your number.');
        } else {
          if (lostEl) lostEl.hidden = false;
        }
      }
    };

    // --- Attach option click handlers ---
    questions.forEach((question) => {
      const feedback = question.querySelector('[data-quiz-feedback]');
      const correct  = question.getAttribute('data-correct');

      question.querySelectorAll('.sweepstake-quiz__option').forEach((option) => {
        option.addEventListener('click', () => {
          question.querySelectorAll('.sweepstake-quiz__option').forEach((item) => {
            item.classList.remove('is-selected');
            item.disabled = true;
          });
          option.classList.add('is-selected');

          const elapsed = Date.now() - questionStart;
          const isCorrect = option.dataset.option === correct;

          if (feedback) {
            feedback.textContent = isCorrect
              ? 'Correct.'
              : `Incorrect. The right answer was option ${correct}.`;
          }

          advanceQuestion(isCorrect, elapsed);
        });
      });
    });

    // --- Retry handler (lost state → back to quiz) ---
    const resetQuiz = () => {
      current   = 0;
      score     = 0;
      totalTime = 0;
      clearResultError();
      // Re-enable all options
      questions.forEach((q) => {
        q.querySelectorAll('.sweepstake-quiz__option').forEach((o) => {
          o.disabled = false;
          o.classList.remove('is-selected');
        });
        const fb = q.querySelector('[data-quiz-feedback]');
        if (fb) fb.textContent = '';
      });
      if (lostEl) lostEl.hidden = true;
      if (successEl) successEl.hidden = true;
      if (gateEl) gateEl.hidden = true;
      bodyEl.hidden = false;
      scrollQuizIntoView();
      render();
    };

    if (retryBtn) {
      retryBtn.addEventListener('click', resetQuiz);
    }

    // --- Ticket gate validation ---
    if (validateBtn && codeInput) {
      const runValidation = async () => {
        hideError(gateError);
        const code = codeInput.value.trim().toUpperCase();

        if (!code) {
          showError(gateError, 'Please enter your ticket code.');
          return;
        }

        setButtonBusy(validateBtn, true);

        try {
          const res = await fetch(`${API_BASE}/api/sweepstake/validate-ticket`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ shop: SHOP, code }),
          });

          const data = await res.json();

          if (data.ok) {
            ticketId   = data.ticketId;
            ticketCode = code;

            // Transition gate → quiz (in-place, no scroll needed)
            gateEl.hidden = true;
            bodyEl.hidden = false;
            render();
          } else {
            const messages = {
              invalid_code: 'That code is not valid. Check your email and try again.',
              expired:      'This ticket has expired.',
              missing_code: 'Please enter your ticket code.',
              rate_limited: 'Too many attempts. Please wait a minute and try again.',
            };

            if (data.error === 'already_won' && data.sweepstakeNumber != null) {
              gateEl.hidden = true;
              if (bodyEl) bodyEl.hidden = true;
              setWinnerState({
                scoreText: 'This ticket already won. Your official sweepstake number is shown below.',
                sweepstakeNumber: data.sweepstakeNumber,
                alreadyRecorded: true,
              });
            } else {
              showError(gateError, messages[data.error] || 'Something went wrong. Please try again.');
            }
          }
        } catch (err) {
          console.error('[sweepstake] validate-ticket error:', err);
          showError(gateError, 'Could not connect. Please check your connection and try again.');
        } finally {
          setButtonBusy(validateBtn, false);
        }
      };

      validateBtn.addEventListener('click', runValidation);
      codeInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') runValidation();
      });
    }
  });

  document.querySelectorAll('[data-entry-form], .sweepstake-entry__form:not([data-sweep-lead-form])').forEach((form) => {
    const errorNode = form.querySelector('[data-form-error]');
    const passwordNode = form.querySelector('[data-generated-password]');

    const clearMessages = () => {
      if (errorNode) errorNode.hidden = true;
    };

    const generatePassword = () => {
      const seed = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
      return `Rr!${seed}A9`;
    };

    form.addEventListener('submit', (event) => {
      clearMessages();

      const fields = Array.from(form.querySelectorAll('input[required]'));
      const invalidField = fields.find((field) => !field.checkValidity());

      if (invalidField) {
        event.preventDefault();
        if (errorNode) {
          errorNode.hidden = false;
          errorNode.textContent = 'Please complete every required field before submitting your entry.';
        }
        invalidField.focus();
        return;
      }

      if (passwordNode && !passwordNode.value) {
        passwordNode.value = generatePassword();
      }

      form.classList.add('is-submitting');
    });

    document.addEventListener('sweepstake:quiz-complete', () => {
      const section = form.closest('[data-entry-form-section]');
      if (section) section.classList.add('is-unlocked');
    });
  });

  document.querySelectorAll('[data-sweep-lead-form]').forEach((form) => {
    const apiBase = (form.dataset.apiBase || '').replace(/\/$/, '');
    const shop = form.dataset.shop || '';
    const source = form.dataset.source || 'Sweepstake lead form';
    const errorNode = form.querySelector('[data-lead-error]');
    const successNode = form.querySelector('[data-lead-success]');
    const submitBtn = form.querySelector('button[type="submit"]');
    const submitLabel = form.querySelector('[data-lead-submit-label]');
    const defaultLabel = submitLabel ? submitLabel.textContent : '';

    const showLeadError = (message) => {
      if (!errorNode) return;
      errorNode.hidden = false;
      errorNode.textContent = message;
    };

    const clearLeadMessages = () => {
      if (errorNode) {
        errorNode.hidden = true;
        errorNode.textContent = '';
      }
      if (successNode) {
        successNode.hidden = true;
      }
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      clearLeadMessages();

      const companyField = form.querySelector('input[name="company"]');
      if (companyField && companyField.value.trim()) {
        form.reset();
        return;
      }

      const fullNameField = form.querySelector('input[name="fullName"]');
      const emailField = form.querySelector('input[name="email"]');
      const phoneField = form.querySelector('input[name="phone"]');
      const requiredFields = [fullNameField, emailField, phoneField].filter(Boolean);
      const invalidField = requiredFields.find((field) => !field.checkValidity());

      if (invalidField) {
        showLeadError('Please complete your name, phone number, and email before sending the request.');
        invalidField.focus();
        return;
      }

      if (!apiBase || !shop) {
        showLeadError('This form is not configured correctly yet. Please contact Speedy Motor Group directly.');
        return;
      }

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-busy', 'true');
      }
      if (submitLabel) submitLabel.textContent = 'Sending...';

      try {
        const res = await fetch(`${apiBase}/api/sweepstake/request-ticket`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            shop,
            fullName: fullNameField.value.trim(),
            email: emailField.value.trim(),
            phone: phoneField.value.trim(),
            pageUrl: window.location.href,
            source,
          }),
        });

        const data = await res.json().catch(() => ({}));

        if (!res.ok || !data.ok) {
          const messages = {
            invalid_payload: 'Please review your details and try again.',
            rate_limited: 'Too many requests. Please wait a minute and try again.',
            notification_failed: 'We could not send your request right now. Please try again in a moment.',
          };
          throw new Error(messages[data.error] || 'Something went wrong. Please try again.');
        }

        form.reset();
        if (successNode) successNode.hidden = false;
      } catch (err) {
        console.error('[sweepstake] request-ticket error:', err);
        showLeadError(err.message || 'Something went wrong. Please try again.');
      } finally {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.setAttribute('aria-busy', 'false');
        }
        if (submitLabel) submitLabel.textContent = defaultLabel;
      }
    });
  });

  document.querySelectorAll('[data-faq]').forEach((faq) => {
    faq.querySelectorAll('details').forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        faq.querySelectorAll('details').forEach((other) => {
          if (other !== item) other.open = false;
        });
      });
    });
  });

  const mobileSticky = document.querySelector('[data-mobile-sticky-cta]');
  const footer = document.querySelector('.shopify-section-group-footer-group');
  if (mobileSticky && footer && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          mobileSticky.classList.toggle('is-hidden', entry.isIntersecting);
        });
      },
      { threshold: 0.05 }
    );
    observer.observe(footer);
  }

  if (!prefersReducedMotion) {
    const hero = document.querySelector('.sweepstake-hero');
    const finalCta = document.querySelector('.sweepstake-final');
    let ticking = false;

    const updateScrollEffects = () => {
      if (hero) {
        const rect = hero.getBoundingClientRect();
        const progress = clamp((0 - rect.top) / Math.max(rect.height, 1), 0, 1);
        hero.style.setProperty('--sweep-hero-progress', progress.toFixed(3));
        hero.style.setProperty('--sweep-hero-shift', `${progress * 26}px`);
        hero.style.setProperty('--sweep-hero-scale', (1 + progress * 0.045).toFixed(3));
        hero.style.setProperty('--sweep-light-sweep', `${-18 + progress * 72}`);
      }

      if (finalCta) {
        const rect = finalCta.getBoundingClientRect();
        const visible = clamp((window.innerHeight - rect.top) / (window.innerHeight + rect.height), 0, 1);
        finalCta.style.setProperty('--sweep-final-progress', visible.toFixed(3));
        finalCta.style.setProperty('--sweep-light-sweep', `${-8 + visible * 58}`);
      }

      ticking = false;
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateScrollEffects);
    };

    updateScrollEffects();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  }
})();
